import React, { useState, useRef, useEffect, PropsWithChildren } from 'react';
import CaretRightIcon from 'assets/icons/caretRight.svg?react';
import styles from './Sidebar.module.css';

interface SidebarSectionProps {
    title: string;
    isExpanded?: boolean;
}

function SidebarSection({ title, children, isExpanded = true }: PropsWithChildren<SidebarSectionProps>) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const contentRef = useRef<HTMLUListElement>(null);
    const [contentHeight, setContentHeight] = useState<number | undefined>(undefined);

    useEffect(() => {
        if (contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        }
    }, [children]);

    // When sidebar collapses, show all items
    const showContent = isExpanded ? !isCollapsed : true;

    return (
        <div className={styles.section}>
            {isExpanded && (
                <div
                    className={styles.sectionTitle}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    role="button"
                    tabIndex={0}
                >
                    {title}
                    <CaretRightIcon
                        className={`${styles.sectionCaret} ${isCollapsed ? styles.collapsedSection : ''}`}
                    />
                </div>
            )}
            <ul
                ref={contentRef}
                className={styles.menuList}
                style={{
                    maxHeight: showContent ? contentHeight : 0,
                    opacity: showContent ? 1 : 0,
                    overflow: 'hidden',
                    transition: 'max-height 0.25s ease, opacity 0.2s ease',
                }}
            >
                {children}
            </ul>
        </div>
    );
}

export default SidebarSection;
